<section class="pb-3 pb-lg-8">
  <div class="row">
    <div class="col-12 col-xl-9">
      <ng-container>
        <!-- `min-h-350px` on a card whose body is one paragraph left a field of
             white under every short article. The content sizes it now. -->
        <div class="card">
          @if (isLoading()) {
          <app-skeleton-details></app-skeleton-details>
          } @else if (notFound()) {
          <div class="card-body">
            <div class="empty-state" data-testid="blog-not-found">
              <span class="empty-state__mark">
                <app-keenicon name="notepad" class="fs-2tx"></app-keenicon>
              </span>
              <p class="empty-state__title">{{ "APP.BLOG_NOT_FOUND" | translate }}</p>
              <p class="empty-state__body">{{ "APP.BLOG_NOT_FOUND_HINT" | translate }}</p>
              <a class="btn btn-primary" routerLink="/blogs">{{ "MENU.BLOG" | translate }}</a>
            </div>
          </div>
          } @else {
          <div class="card-header">
            <div class="d-lg-none align-items-center px-5 px-lg-9 py-5 gap-5">
              <app-breadcrumb-custom type="bc" [title]="blog_info.name"></app-breadcrumb-custom>
            </div>
            <section #intro class="py-8">
              <div class="d-flex flex-wrap gap-2 justify-content-between align-items-center mb-3">
                <div class="d-flex align-items-center flex-wrap gap-2">
                  <h1 class="fw-bold me-3 my-1" data-testid="blog-title">{{ blog_info.name }}</h1>

                  <!-- The section an article belongs to is not an alarm.
                         `badge-light-danger` painted every category pink, and
                         the SAME category is a sky chip on the list two clicks
                         away. -->
                  <span class="badge badge-light-primary my-1 me-2">{{
                    blog_info.blog_category_name
                    }}</span>
                  <!-- <span class="badge badge-light-danger my-1">important</span> -->
                </div>
              </div>
              <div class="d-flex gap-6">
                <div class="d-flex align-items-center gap-2">
                  <app-keenicon name="calendar-tick" class="fs-2 text-gray-600"></app-keenicon>
                  <span class="text-gray-600 d-block fs-6 fw-semibold mt-0">{{
                    blog_info.created_at | customDate
                    }}</span>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <app-keenicon name="user-edit" class="fs-2 text-gray-600"></app-keenicon>
                  <span class="text-gray-600 d-block fs-6 fw-semibold mt-0">
                    {{ blog_info.tutor_name }}
                  </span>
                </div>
              </div>
            </section>
          </div>

          <!-- The article's cover. The list gives every post one — a tinted
                 panel carrying the demo's own subject art — and the page you
                 land on from it had none, so an article opened on a bare title
                 above two lines of grey. Same tint and same icon as the card
                 that was clicked, because both are keyed off the post's id. -->
          <div class="card-body pt-0">
            <!-- @if (blog_info.blog_img) {
              <img class="blog-hero rounded-nested" [src]="blog_info.blog_img" [attr.alt]="blog_info.name" />
              } @else {
              <div class="blog-hero blog-cover rounded-nested" [ngClass]="coverTint()">
                <img class="blog-cover__art" [src]="coverArt()" alt="" />
              </div>
              } -->
            <section #courseDesp class="pt-8">
              <div class="fs-4 fw-normal blog-content overflow-auto" [innerHTML]="blog_info.article"></div>
            </section>
          </div>
          }
        </div>
      </ng-container>
    </div>
    <div class="d-none d-xl-block col-3 pisition-relative">
      <section class="side-drawer">
        <ng-container *ngTemplateOutlet="sideDrawer"></ng-container>
      </section>
    </div>
  </div>
</section>

<ng-template #sideDrawer>
  @if (isLoading()) {
  <app-skeleton-right-side></app-skeleton-right-side>
  } @else {
  <div class="card card-flush h-xl-100 m-auto">
    <div class="card-body text-start">
      <div class="flex-column flex-lg-row-auto w-100 mb-10">
        <div class="mb-16" [formGroup]="form">
          <h4 class="text-gray-900 mb-7">
            {{ "APP.SEARCH_BLOG" | translate }}
          </h4>

          <div class="position-relative">
            <i class="ki-duotone ki-magnifier fs-3 text-gray-500 position-absolute top-50 translate-middle ms-6"><span
                class="path1"></span><span class="path2"></span></i>
            <input type="text" class="form-control form-control-solid ps-10" name="search" value=""
              [placeholder]="'APP.SEARCH' | translate" formControlName="keywords" />
          </div>
        </div>

        <!--begin::Recent posts-->
        <div class="m-0">
          <h4 class="text-gray-900 mb-7">
            {{ "APP.RECENT_BLOG" | translate }}
          </h4>

          @if (searchLoading()) {
          } @else {
          @if (blogs.length) {
          @for (blog of blogs; track $index; let j = $index) {
          <div class="d-flex flex-stack mb-7">
            <div class="symbol symbol-60px symbol-2by3 me-4">
              @if (blog.blog_img) {
              <img class="symbol-label object-fit-cover object-position-top" [src]="blog.blog_img" />
              } @else {
              <!-- Was a hard-coded path into the Metronic demo's own
                             asset tree (`/metronic8/demo1/...`), which 404s in
                             this app — so every thumbnail in this rail was an
                             empty grey box. -->
              <div class="symbol-label blog-cover blog-cover--thumb" [ngClass]="coverTint(blog.id)">
                <img class="blog-cover__art" [src]="coverArt(blog.id)" alt="" />
              </div>
              }
            </div>

            <div class="m-0 flex-fill">
              <a (click)="routerBlog(blog.id)" class="text-gray-800 fw-bold text-hover-primary fs-6 cursor-pointer">{{
                blog.name }}</a>

              <span class="text-gray-600 d-block pt-1 fs-7">{{ "APP.PUBLIC" | translate }}:
                {{
                blog.is_today
                ? "วันนี้"
                : (blog.created_at | customDate)
                }}</span>
            </div>
          </div>
          }
          } @else {
          <p class="text-muted">{{ "TABLE.NO_DATA" | translate }}</p>
          }
          }

          <!--end::Item-->
        </div>
        <!--end::Recent posts-->
      </div>
    </div>
  </div>
  }
</ng-template>